<template>
  <div class="DatePickermain">
      <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
              <v-text-field :class="[currentField.required?required_class:currentField.clearable?read_only:others]" :readonly="currentField.clearable" :disabled='currentField.disabled' :placeholder="`${currentField.isPlaceholderVisible ? currentField.placeholder : ''}`"  v-model="currentField.value.value" :label="`${currentField.label}`"  v-bind="attrs" v-on="on" :rules="required_rule"></v-text-field>
          </template>
          <v-date-picker  :readonly="currentField.clearable" :disabled='currentField.disabled' v-model="currentField.value.value" @input="menu = false"></v-date-picker>
      </v-menu>
  
  </div>
  </template>
  

<script>
export default {
  name: "DatePicker",
  props: ["currentField"],
  data() {
      return {
          date: "",
          menu: false,
          required_class:"required",
          others:"others",
           read_only:"readonly",
           required_rule:[]
      };
  },
  destroyed() {
      this.currentField.value.value = '';
  },
  methods: {
      
  },
  computed: {
      attributesBinding() {
          var attr = {};
          attr["id"] = this.currentField.model;
          attr.disabled = this.currentField.disabled;
          return attr;
      },
  },
  mounted() {
      if(this.currentField.required == true){
          this.required_rule = [ v => !!v || `${this.currentField.label} is required`]
      }
      
  }
};
</script>

<style>
.DatePickermain {
  height: 85px;
  padding: 10px;
}
.required:after {
  content:" *";
  color: rgb(255, 0, 0);
  font-weight: 600;
  padding-left:2px ;
}

.readonly:after {
  content:" *";
  color: rgb(4, 0, 255);
  font-weight: 600;
  padding-left:2px ;
}

.others:after{
  content:"";
  font-weight: 600;
  padding-left:2px ;
}

</style>
